export default "__VITE_ASSET__BMWB5z9Q__"